import { httpRequest } from "../../http";
import { CatalogEntityType } from "@models/catalog.model";

export class CommandListEntityTypes {
  async run(verticalCode?: string): Promise<CatalogEntityType[]> {
    const base = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/catalog/entity-types/`;
    const url = verticalCode ? `${base}?vertical=${encodeURIComponent(verticalCode)}` : base;
    return httpRequest<CatalogEntityType[]>(url, { method: "GET" });
  }
}
